module.exports = __webpack_public_path__ + "static/media/end.c2827001.png";